/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { isNegativeAmount } from '../../../utils/ej-utils';
import { currencyFormatter } from '../../../utils/formatting';
import DiscountFormatter from '../DiscountFormatter';

const PriceOverride = ({
  saleItems,
}) => {
  const {
    locale: { storeCurrency, storeLocale }, RL_Difference, RL_PriceOvr, RL_OrgPrice
  } = useSelector((state) => state);

  const amount = (number) => currencyFormatter(storeLocale, storeCurrency, number);
  const differenceAmount = (number) => amount(Math.abs(number));

  return (
    <>
      {saleItems.map((item, index) => (
        item?.RetailPriceModifiers?.map((price, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <section key={`${item?.Item?.ID || 'item'}-${index}-${idx}`}>
            {(price?.NewPrice && price?.PreviousPrice) && (
              <>
                <article className="justify-between">
                  <p>{RL_PriceOvr}.: {item?.Item?.ID}</p>
                </article>
                <article className="justify-between">
                  <p className="pl2-sm">{RL_OrgPrice}: {amount(price?.PreviousPrice?.Amount)}</p>
                </article>
                <article className="justify-between">
                  <p className="pl2-sm">{RL_Difference}:  <DiscountFormatter isNegative={isNegativeAmount(price?.NewPrice?.Amount - price?.PreviousPrice?.Amount)} storeLocale={storeLocale}>{differenceAmount(price?.NewPrice?.Amount - price?.PreviousPrice?.Amount)}</DiscountFormatter>
                  </p>
                </article>
                {index === saleItems?.length - 1 && idx === item?.RetailPriceModifiers?.length - 1 && (<><br /><br /></>)}
              </>
            )}
          </section>
        ))
      ))}
    </>
  );
};

PriceOverride.defaultProps = {
  saleItems: [],
};

PriceOverride.propTypes = {
  saleItems: PropTypes.arrayOf(PropTypes.shape()),
};

export default PriceOverride;
